module.exports = __webpack_public_path__ + "img/07.0e288cdb.jpg";